import React, { FC } from 'react'
import { Button } from 'react-bootstrap'

import { reinviteUser } from 'state/async_actions'
import { useAppContext } from 'state/context'

interface ReinviteButtonProps {
  onClick: () => void
}

export interface InvitedUserProps {
  isRegistered: boolean
  display: string
  id: number
}

export const ReinviteButton: FC<ReinviteButtonProps> = ({ onClick }) => (
  <Button className="btn-reinvite" onClick={onClick}>
    Resend Invitation
  </Button>
)

export const InvitedUser: FC<InvitedUserProps> = ({
  isRegistered,
  display,
  id,
}) => {
  const [, dispatch] = useAppContext()

  const sendReinvitation = (userId: number) => {
    reinviteUser(dispatch, userId)
  }

  const onClick = () => sendReinvitation(id)

  return (
    <li key={id}>
      {display}
      {isRegistered || <ReinviteButton onClick={onClick} />}
    </li>
  )
}
